
import { Component, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';

import { BookingsApi } from '@/api/BookingsApi';

import slugify from 'slugify';

import { MetaInfo } from 'vue-meta';

import { sortBy, first, mapValues, find } from 'lodash';

import { striposMixin } from '@/mixins/striposMixin.js';

import { colorTooltipsMixin } from '@/mixins/colorTooltipsMixin.js';

import { findColor } from '@/config/functions';
import { TasksApi } from '@/api/TasksApi';

@Component({
   metaInfo(): MetaInfo {
      return {
         title: 'Tasks list',
      };
   },
   mixins: [striposMixin, colorTooltipsMixin],
})
export default class Activities extends Booking {
   form: any;

   stripos!: any;

   addColorTooltips!: any;

   activities_colors!: any[];

   fields: any[] = [
      {
         key: 'task_status',
         label: 'status',
         thAttr: {
            style: 'width: 43px;',
         },
      },
      {
         key: 'o_group_color',
         label: 'group color',
         thAttr: {
            style: 'width: 43px;',
         },
      },
      {
         key: 'o_lead_guest',
         sortable: true,
         label: 'lead guest',
         thAttr: {
            style: 'width: 232px;',
         },
      },
      {
         key: 'o_our_reference',
         sortable: true,
         label: 'our ref',
      },
      {
         key: 'o_agent',
         sortable: true,
         label: 'agent',
      },
      {
         key: 'o_check_in_date',
         sortable: true,
         label: 'check in date',
      },
      {
         key: 'due_date',
         sortable: true,
         label: 'due date',
      },
      {
         key: 'days_left',
         sortable: true,
         label: 'days left',
      },
      {
         key: 'task_name',
         label: 'Task',
      },
      {
         key: 'task_trigger',
         sortable: true,
         label: 'Trigger',
      },
   ];

   rooms: any[] = [];

   tasks: any[] = [];

   filtered: any[] = [];

   dataReady!: boolean;

   filter: any = {
      o_group_color: '#FEFEFE',
      task_status: '#ffffff',
   };

   dateRange: Date[] = [];

   created(): void {
      const $start = this.$moment(this.$localStorage.getItem(this.$route.name + '.startDate'));
      const $end = this.$moment(this.$localStorage.getItem(this.$route.name + '.endDate'));

      this.dateRange = [
         $start.isValid() ? $start.toDate() : this.$moment().toDate(),
         $end.isValid()
            ? $end.toDate()
            : this.$moment()
                 .add(30, 'd')
                 .toDate(),
      ];

      this.filter = {
         ...this.filter,
         ...mapValues(this.$route.query, (val: string) => {
            const value = val.split(';');
            return value.length == 1 ? first(value) : value;
         }),
      };
   }

   @Watch('$route', { immediate: false, deep: true })
   onRoute(n: any, o: any) {
      if (n.name !== o.name) {
         this.findOrders();
      }
   }

   filterData() {
      const filter = {
         o_lead_guest: '',
         due_date: '',
         o_our_reference: '',
         o_group_color: '#FEFEFE',
         o_agent: '',
         ...this.filter,
      };

      this.filtered = this.tasks
         .map(a => ({
            ...a,
            task_status: find(this.activities_colors, { id: a['task_status.d_id'] })?.d_color_code,
            f_lead_guest: a.o_lead_guest != null ? slugify(a.o_lead_guest).toUpperCase() : '',
            f_our_reference: parseFloat(a.o_our_reference),
         }))
         .filter(a => {
            const filtered: any = {
               o_lead_guest: this.stripos(a.f_lead_guest, filter.o_lead_guest),
            };

            for (const f of Object.keys(filter)) {
               if (!a[f] || Object.keys(filtered).includes(f)) continue;

               if (f.indexOf('_status') >= 0 || f.indexOf('_color') >= 0) {
                  filtered[f] = !filter[f].length || findColor(filter[f], a[f], this.default_colors[f], this.activities_colors);
                  continue;
               }

               filtered[f] = filter[f] === '' || this.stripos(a[f], filter[f]);
            }

            return Object.keys(filtered).length == Object.values(filtered).filter(f => f).length;
         });
   }

   changeTaskColor(order: any, d_color_code: string) {
      order.task_status = d_color_code;
      BookingsApi.saveOrder(order.o_id, {
         'change-task-status': find(this.activities_colors, { d_color_code })?.id,
         task_num: order.task_num,
      });
   }

   findOrders() {
      if (!this.dataReady) {
         setTimeout(() => this.findOrders(), 1000);
         return;
      }

      this.$store.commit('showLoading');
      this.$store.commit('setItems', { name: 'ready', value: false });

      TasksApi.find({
         dateFrom: this.$moment(this.dateRange[0]).format('YYYY-MM-DD'),
         dateTo: this.$moment(this.dateRange[1]).format('YYYY-MM-DD'),
         archive: this.$route.name == 'archive' ? 1 : 0,
      })
         .then(({ Tasks }) => {
            this.tasks = sortBy(Tasks, 'due_date');
            this.filterData();
         })
         .finally(() => {
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }

   @Watch('dateRange', { immediate: false, deep: true })
   onChangeDateRange(n: string[], o: string[]) {
      const nn = n.map(d => this.$moment(d).format('YYYY-MM-DD'));
      const oo = o.map(d => this.$moment(d).format('YYYY-MM-DD'));

      if (nn.length && JSON.stringify(nn) !== JSON.stringify(oo)) {
         this.$localStorage.setItem(this.$route.name + '.startDate', n[0]);
         this.$localStorage.setItem(this.$route.name + '.endDate', n[1]);
         this.findOrders();
      }
   }

   @Watch('tasks', { deep: true })
   changeTasks() {
      this.addColorTooltips(['.orders-list'], this.activities_colors);
   }

   @Watch('filter', { immediate: true, deep: true })
   changeFilter(filter: any) {
      const query = mapValues({ ...this.$route.query, ...filter }, value => {
         return Array.isArray(value) ? value.join(';') : value;
      });

      this.$router.push({ query }).catch(() => {});

      this.filterData();
   }
}
